<template>
  <section :class="{'no-title': !subTitle}" class="hero">
    <img :src="heroImage" loading="eager" alt="청년주택 대표 이미지" class="hero-image" />
    <div class="hero-text">
      <h2 class="main-title" :class="{'no-title': !subTitle}">{{ subTitle }}</h2>
    </div>
  </section>
  </template>
  
  <script setup>
  import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const subTitle = ref('');

// 라우트별 타이틀 매핑
const titleMap = {
  '/requirement': '자격 조건',
  '/requirement/documents': '제출 서류',
  '/introduction': '사업 안내',
  '/environment': '세대 평면도',
  '/environment/community': '커뮤니티 시설',
  '/apply': '청약신청',
  '/apply/edit': '청약수정',
  '/inquiry': '청약조회',
  '/apply/finance': '금융 지원',
  '/notice': '공지사항',
  '/notice/detail': '공지사항',
  '/notice/resources': '자료실',
  '/resources/detail': '자료실',
  '/map': '오시는길',
  default: ''
};

const getTitleByPath = (path) => {
  // 동적 상세 페이지 (예: /notice/detail/22, /notice/resources/99)
  if (path.startsWith('/notice/detail')) return '공지사항';
  if (path.startsWith('/notice/resources')) return '자료실';
  if (path.startsWith('/resources/detail')) return '자료실';
  if (path.startsWith('/requirement/documents')) return '제출 서류';
  if (path.startsWith('/requirement')) return '자격 조건';
  if (path.startsWith('/environment/community')) return '커뮤니티 시설';
  if (path.startsWith('/environment')) return '세대 평면도';
  if (path.startsWith('/apply/finance')) return '금융 지원';
  if (path.startsWith('/apply/edit')) return '청약수정';
  if (path.startsWith('/apply')) return '청약신청';
  if (path.startsWith('/inquiry')) return '청약조회';
  if (path.startsWith('/introduction')) return '사업 안내';
  if (path.startsWith('/map')) return '오시는길';

  // 완전일치 우선
  return titleMap[path] || titleMap.default;
};

// ✅ public/image 경로 기준 이미지 파일명 매핑
const imageMap = {
  '/requirement': '/image/sub-requirement.jpg',
  '/requirement/documents': '/image/sub-document.jpg',
  '/introduction': '/image/sub-introduction.jpg',
  '/environment': '/image/sub-environment.jpg',
  '/environment/community': '/image/sub-community.jpg',
  '/apply': '/image/sub-apply.jpg',
  '/apply/edit': '/image/sub-apply.jpg',
  '/apply/finance': '/image/sub-finance.jpg',
  '/notice': '/image/sub-notice.jpg',
  '/notice/detail': '/image/sub-notice.jpg',
  '/notice/resources': '/image/sub-resource.jpg',
  '/resources/detail': '/image/sub-resource.jpg',
  '/map': '/image/mapcontact.jpg',
  '/inquiry': '/image/sub-apply.jpg',
  
};

const getImageByPath = (path) => {
  if (path.startsWith('/notice/detail')) return imageMap['/notice/detail'];
  if (path.startsWith('/notice/resources')) return imageMap['/notice/resources'];
  if (path.startsWith('/resources/detail')) return imageMap['/resources/detail'];
  if (path.startsWith('/requirement/documents')) return imageMap['/requirement/documents'];
  if (path.startsWith('/requirement')) return imageMap['/requirement'];
  if (path.startsWith('/environment/community')) return imageMap['/environment/community'];
  if (path.startsWith('/environment')) return imageMap['/environment'];
  if (path.startsWith('/apply/finance')) return imageMap['/apply/finance'];
  if (path.startsWith('/apply')) return imageMap['/apply'];
  if (path.startsWith('/inquiry')) return imageMap['/inquiry'];
  if (path.startsWith('/introduction')) return imageMap['/introduction'];
  if (path.startsWith('/map')) return imageMap['/map'];
  return imageMap[path] || imageMap.default;
};


// 경로에 따른 타이틀 설정
watch(
  () => route.path,
  (newPath) => {
    subTitle.value = newPath === '/' ? '' : getTitleByPath(newPath);
  },
  { immediate: true }
);

const heroImage = computed(() => getImageByPath(route.path));

// 이미지 설정

  </script>
  
  <style scoped>
  .no-title {
    display: none; /* 홈 페이지에서는 제목을 숨깁니다 */
  }
  
  /* Hero */
  .hero {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  
  .hero-image {
    width: 100vw;
    max-height: 300px;
    object-fit: cover; /* 이미지가 부모 영역을 꽉 채우게 설정 */
    
  }
  
  .hero-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); /* 텍스트를 정확히 중앙에 위치시킴 */
    color: white;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
    text-align: center;
  }
  
  .main-title {
    padding-top: 90px;
    font-size: 2.5rem;
    font-weight: 700;
  }
  
  .hero-subtitle {
    font-size: 1.2rem;
  }

  /* 반응형 스타일 */
@media (max-width: 768px) {
  .main-title {
    padding-top: 90px;
    font-size: 1.9rem;
    font-weight: 700;
  }
  
  .hero-subtitle {
    font-size: 1.2rem;
  }
}
  </style>
  